<template>
  <div v-if="visible" class="custom-dialog-overlay" @click="handleClose">
    <div class="custom-dialog" @click.stop>
      <img src="@/assets/img/pubclose.png" alt="" @click="handleClose" class="clImg">

      <div class="custom-dialog-header">
        {{ title }}
      </div>
      <div class="descHeader">
        实时更新全国建筑工程项目需求信息
      </div>
      <div class="custom-dialog-body">
        <div class="release-type-options">
          <div v-for="type in releaseTypes" :key="type.value" class="release-type-option"
            @click="selectReleaseType(type.value)">
            <div style="display: flex;align-items: center;">
              <img class="leftimg" :src="type.img" alt="">
              <span>{{ type.name }}</span>
            </div>
            <img class="rigtimg" src="@/assets/img/rightic.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PublishTypeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '信息发布'
    },
  },
  data() {
    return {
      // 发布类型选项
      releaseTypes: [
        { name: '公司转让', value: 'equity', img: require('@/assets/img/compony.png') },
        { name: '技术负责人', value: 'technical', img: require('@/assets/img/publish2.png') },
        { name: '注册师', value: 'registered', img: require('@/assets/img/publish3.png') },
        { name: '求购市场', value: 'purchaseMarket', img: require('@/assets/img/publish4.png') },
        // { name: '资质代办', value: 'qservices', img: require('@/assets/img/publish4.png') }
      ]
    };
  },
  methods: {
    // 选择发布类型
    selectReleaseType(type) {
      this.$emit('close');
      // 根据选择的类型跳转到不同页面
      switch (type) {
        case 'equity':
          this.$router.push({ path: '/releaseEquityInfo' });
          break;
        case 'technical':
          this.$router.push({ path: '/releaseTechnicalLead' });
          break;
        case 'registered':
          this.$router.push({ path: '/releaseRegistered' });
          break;
        case 'purchaseMarket':
          this.$router.push({ path: '/releasePurchase' });
          break;
        case 'qservices':
          this.$router.push({ path: '/releaseQservices' });
          break;
      }
    },
    // 关闭弹框
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.custom-dialog {
  width: 490px;
  height: 520px;
  background-color: #fff;
  background: linear-gradient(180deg, #E4EFFF 0%, #FFFFFF 40%, #FFFFFF 100%);
  overflow: hidden;
  padding: 35px 45px;
  box-sizing: border-box;
  position: relative;

  .clImg {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
}

.custom-dialog-header {
  font-weight: bold;
  font-size: 24px;
  color: #333333;
  line-height: 31px;
  text-align: left;
  font-style: normal;
}

.descHeader {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 19px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}



.custom-dialog-body {
  // padding: 20px;
  position: relative;
}

.release-type-options {
  display: flex;
  flex-direction: column;
}

.release-type-option {
  width: 400px;
  height: 82px;
  background: #F4F7FF;
  display: flex;
  align-items: center;
  background: #F4F7FF;
  border: 1px solid #CBDDF4;
  cursor: pointer;
  padding: 15px 30px 15px 24px;
  box-sizing: border-box;
  justify-content: space-between;
  transition: all 0.3s ease;
  font-size: 16px;
  color: #333333;
  line-height: 21px;
  text-align: left;
  font-style: normal;
  margin-bottom: 10px;

  &:hover {
    transform: scale(1.04);
  }

  .leftimg {
    width: 46px;
    height: 46px;
    margin-right: 25px;
    img{
      width: 100%;
      height: 100%;
    }
  }

  .rigtimg {
    width: 11px;
    height: 15px;
  }

}

.custom-dialog-footer {
  padding: 15px 20px 20px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: center;
}
</style>